import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { TravelinfoService } from 'src/services/travelinfo.service';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from '@env/environment';
@Component({
  selector: 'app-travel-info',
  templateUrl: './travel-info.component.html',
  styleUrls: ['./travel-info.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class TravelInfoComponent implements OnInit {
  public selectedPage: any;
  public travelInfoData: any = { bannerImage: null, bannerTitle: null, content: null, bannerContent: null };
  travelInfoSelectedData: any = { bannerTitle: null, bannerImage: null, content: null, bannerContent: null };
  travelInfoDataItems: any = [];
  public showGalleryItemPopup = false;
  public selectedGalleryItem: any = null;
  public travelInfoDataNew: any = { bannerContent: null };
  travelAdvisory: any = { bannerImage: null, bannerTitle: null, bannerContent: null };
  travelEssesntial: any = { bannerImage: null, bannerTitle: null, bannerContent: null };
  bestTimeToVisit: any = { bannerImage: null, bannerTitle: null, bannerContent: null };
  generalService: any = { bannerImage: null, bannerTitle: null, content: null };
  infoServices: any = { bannerImage: null, bannerTitle: null, content: null };
  index: number = 0;
  activeState: any = [];
  travelInfoItemsLength: number;
  showAdvisory = true;
  activeIndex: any;

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  displayCustom: boolean;
  images: any = [];

  constructor(
    private route: ActivatedRoute,
    private travelinfoService: TravelinfoService,
    private messageService: MessageService,
    private router: Router,
    private titleService: Title,
    private meta: Meta
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((paramMap) => {
      const page = paramMap.get('selectedPage');
      this.selectedPage = page === 'travelinformation' ? 'travel-info' : page;
      this.getDetails();
      this.getTravelInfoItems();
      this.getTravelAdvisoryDetails('travel-essentials');
      this.activeState[0] = true;
    });
  }
  ngAfterContentChecked() {
    var elem = document.getElementById('' + this.index);
    if (elem) {
      elem.classList.add('active');
    }
  }

  getDetails() {
    this.travelinfoService.getTravelInfoDetails(this.selectedPage).subscribe((travelInfo) => {
      if (travelInfo) {
        this.travelInfoData = travelInfo;
        this.images.push(this.travelInfoData.bannerImage);
      }
    });
  }

  getTravelAdvisoryDetails(selectedVal: any) {
    this.travelinfoService.getTravelInfoDetails(selectedVal).subscribe((travelInfo) => {
      if (travelInfo) {
        this.travelInfoSelectedData = travelInfo;
        this.titleService.setTitle(this.travelInfoSelectedData.bannerTitle + ' ' + '| The Seychelles Islands');
      }
    });
    this.travelinfoService.getTravelAdvisoryDetailsNew().subscribe((travelInfoNew) => {
      if (travelInfoNew) {
        this.travelInfoDataNew = travelInfoNew;
        this.travelinfoService.getTravelDetails().subscribe((travelInfo) => {
          this.travelInfoDataNew.travelGallery = [];
          this.travelInfoDataNew.travelGallery2 = [];
          for (var i = 0; i < travelInfo.results.length; i++) {
            // let imgurl = environment.BaseURL.toLowerCase() + '/' + travelInfo.results[i].field_image;
            let imgurl = travelInfo.results[i].field_image;
            var json = {
              gridPopupTitle: travelInfo.results[i].field_popup_title.replace('&#039;', "'"),
              gridTitle: travelInfo.results[i].title.replace('&#039;', "'"),
              url: imgurl,
              gridPopupDescription: travelInfo.results[i].body.replace('&#039;', "'"),
            };
            if (i <= 5) {
              this.travelInfoDataNew.travelGallery.push(json);
            } else {
              this.travelInfoDataNew.travelGallery2.push(json);
            }
          }
        });
      }
    });
  }

  openGalleryItemPopup(item: any) {
    this.showGalleryItemPopup = true;
    this.selectedGalleryItem = item;
  }

  closeGalleryItemPopup() {
    this.showGalleryItemPopup = false;
    this.selectedGalleryItem = null;
  }
  getTravelInfoItems() {
    let travelAdvisory = this.travelinfoService.getTravelAdvisoryDetailsNew();
    let travelEssesntial = this.travelinfoService.getTravelEssentialDetails();
    let bestTimeToVisit = this.travelinfoService.getBestTimeToVisitDetails();

    forkJoin([travelAdvisory, travelEssesntial, bestTimeToVisit]).subscribe(
      (results) => {
        if (results) {
          results.forEach((item) => {
            if (item.bannerTitle === 'Travel Advisory') {
              item['link'] = 'travel-advisory';
            }
          });
          this.travelInfoDataItems = results;
          this.travelInfoItemsLength = results.length;
        }
      },
      (err) => {
        this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
      }
    );
    // this.travelinfoService.getGeneralServiceDetails().subscribe((results) => {
    //   if (results) {
    //     this.generalService = results;
    //   }
    // });
    this.travelinfoService.getInformationServices().subscribe((results) => {
      if (results) {
        this.infoServices = results;
        if (results.metaTitle) {
          this.meta.updateTag({ name: 'title', content: results.metaTitle });
          this.titleService.setTitle(results.metaTitle);
        }
        if (results.metaKeywords) {
          this.meta.updateTag({ name: 'keywords', content: results.metaKeywords });
        }
        if (results.metaDescription) {
          this.meta.updateTag({ name: 'description', content: results.metaDescription });
        }
      }
    });
  }

  getTravelInfoDetails(selectedValue: any, index?: any) {
    this.index = index;
    for (var i = 0; i < this.travelInfoItemsLength; i++) {
      document.getElementById('' + i).classList.remove('active');
    }
    if (selectedValue === 'GENSERVICE') {
      // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/planyourvisit', 'generalservices']);
      // );
    } else if (selectedValue === 'INFO') {
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/planyourvisit', 'informationservices']));
    } else if (selectedValue.link === 'travel-advisory') {
      this.showAdvisory = true;
    } else {
      this.showAdvisory = false;
      this.travelinfoService.getTravelInfoDetails(selectedValue.link).subscribe((travelInfo) => {
        if (travelInfo) {
          this.travelInfoSelectedData = travelInfo;
        }
      });
    }
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
  onTabClose(event: any) {
    this.activeState[event.index] = !this.activeState[event.index];
  }

  onTabOpen(event: any) {
    this.activeState[event.index] = !this.activeState[event.index];
  }
}
